export default function HealthClasses(isVssEnabled, isBelowAverage,height,weight) {
  let options = [
    { label: "Exceptionally healthy (Preferred Plus)", value: "PP" },
    { label: "Very healthy (Preferred)", value: "P" },
    { label: "Above average health (Standard Plus)", value: "RP" },
    { label: "Average health (Standard)", value: "R" }
  ];
  if(isBelowAverage){
    options.push({ label: "Below average health (Substandard)", value: "RR" });
  } 
  if(isVssEnabled && height!=="" && weight!==""){
    options.push({ label: "Personalized Health Class", value: "Personalized Health Class" });
  }
  return options;
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/HealthClasses.js